import { render, staticRenderFns } from "./MacroActivities.vue?vue&type=template&id=1608d7a0&scoped=true&"
import script from "./MacroActivities.vue?vue&type=script&lang=js&"
export * from "./MacroActivities.vue?vue&type=script&lang=js&"
import style0 from "./MacroActivities.vue?vue&type=style&index=0&id=1608d7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608d7a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VDataTable,VDivider,VIcon})
